import {
  SearchResponseSchema,
  type CardOriginChannel,
  type CardSearchResult,
} from '@voll-intelligence/domain';
import type { HttpService } from '@web/data/services';

interface SearchParams {
  q?: string;
  channels?: CardOriginChannel[];
  createdFrom?: Date;
  limit?: number;
}

export interface SearchRepository {
  search: (orgId: string, params: SearchParams) => Promise<CardSearchResult[]>;
}

export function createSearchRepository(http: HttpService): SearchRepository {
  return {
    search: async (orgId, params) => {
      const out = await http.get(`/orgs/${encodeURIComponent(orgId)}/search`, {
        query: {
          q: params.q,
          limit: params.limit ?? 20,
          channels: params.channels?.length ? params.channels.join(',') : undefined,
          createdFrom: params.createdFrom?.toISOString(),
        },
        schema: SearchResponseSchema,
      });
      return out.results;
    },
  };
}
